import { useCallback } from 'react';

import { useConfirmPopup } from 'src/components/ConfirmPopup';

export const useConfirmReplaceBrief = () => {
  const confirmPopup = useConfirmPopup();

  return useCallback(() => {
    return confirmPopup({
      title: 'Replace brief',
      content: 'Are you sure you want to replace the existing brief?',
      buttons: {
        confirm: 'Replace',
      },
      withReject: true,
    })
      .then(() => true)
      .catch(() => false);
  }, [confirmPopup]);
};
